import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Home as HomeIcon, Phone } from "lucide-react";
import { communities, img, company } from "../mock";
import Seo from "../components/Seo";

const PageHero = ({ title, crumb, image }) => (
  <section className="mh-page-hero" style={{ backgroundImage: `url(${image})` }}>
    <div className="mh-page-hero-inner">
      <div className="mh-crumb"><Link to="/">Home</Link> / {crumb}</div>
      <h1>{title}</h1>
    </div>
  </section>
);

const AvailableHomes = () => {
  useEffect(() => {
    const obs = new IntersectionObserver((es) => es.forEach((e) => e.isIntersecting && e.target.classList.add("in")), { threshold: 0.1 });
    document.querySelectorAll(".mh-reveal").forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return (
    <div>
      <Seo
        title="Available Homes"
        description="Explore available new homes and homesites from Monarch Homes of Brevard across Brevard County and the Space Coast, or build a custom home on your own lot."
        keywords="available homes Brevard County, new homes Melbourne FL, Space Coast homes, Viera new construction"
        path="/available-homes"
      />
      <PageHero title="Available Homes" crumb="Available Homes" image={img.ext2} />

      <section className="mh-section">
        <div className="mh-container">
          <div className="mh-empty-state mh-reveal">
            <div className="mh-empty-icon"><HomeIcon size={40} /></div>
            <div className="mh-eyebrow">Available Homes</div>
            <h2>No Homes Currently Available</h2>
            <p>We don&rsquo;t have any move-in-ready homes available at this time. New opportunities become available throughout the year, so please check back soon or reach out to be notified when a home or homesite is released.</p>
            <p>In the meantime, we&rsquo;d love to build your dream home. We can build one of our floor plans, your own plan, or a fully custom design on your personal lot throughout much of Brevard County.</p>
            <div className="mh-hero-actions" style={{ justifyContent: "center" }}>
              <Link to="/contact" className="mh-cta-btn">Contact Us <ArrowRight size={16} /></Link>
              <Link to="/build-on-your-lot" className="mh-btn-outline">Build On Your Lot</Link>
            </div>
            <a href={company.phoneHref} className="mh-empty-phone"><Phone size={15} /> {company.phone}</a>
          </div>
        </div>
      </section>

      <section className="mh-section cream tight">
        <div className="mh-container">
          <div className="mh-section-head mh-reveal">
            <div className="mh-eyebrow">Our Communities</div>
            <h2>Neighborhoods We Build In</h2>
            <div className="mh-divider" />
          </div>
          <div className="mh-grid-3">
            {communities.map((c, i) => (
              <div key={i} className="mh-comm-card mh-reveal">
                <img src={c.image} alt={c.name} loading="lazy" />
                <div className="mh-comm-body">
                  <h3>{c.name}</h3>
                  <p>{c.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="mh-cta-band">
        <div className="mh-container mh-reveal">
          <h2>Don&rsquo;t See The Perfect Fit?</h2>
          <p>We can build one of our floor plans, your own plan, or a fully custom design on your personal lot throughout much of Brevard County.</p>
          <div className="mh-hero-actions">
            <Link to="/build-on-your-lot" className="mh-cta-btn">Build On Your Lot <ArrowRight size={16} /></Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AvailableHomes;
